"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = __importDefault(require("./jsonrpc/parse"));
var RpcNotification_1 = __importDefault(require("./jsonrpc/request/RpcNotification"));
var BrowserAbortError_1 = __importDefault(require("./jsonrpc/response/BrowserAbortError"));
var CallManager_1 = __importDefault(require("./CallManager"));
var api_1 = require("@opentelemetry/api");
var isBrowser = typeof window !== 'undefined';
var tracer = api_1.trace.getTracer('json-rpc-dispatcher');
var Dispatcher = /** @class */ (function () {
    function Dispatcher(adapter) {
        var _this = this;
        this.isLocationChanged = false;
        this.call = function (payload, options) {
            if (options === void 0) { options = {}; }
            return _this.callManager.exec(function (payload, options) { return __awaiter(_this, void 0, void 0, function () {
                var requestObject, response;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.execRequestInterceptors((0, parse_1.default)(payload))];
                        case 1:
                            requestObject = _a.sent();
                            return [4 /*yield*/, tracer.startActiveSpan('json-rpc.Dispatcher.call', {
                                    attributes: {
                                        adapter: this.adapter.constructor.name,
                                        'rpc.method': payload.method,
                                    },
                                }, function (span) { return __awaiter(_this, void 0, void 0, function () {
                                    var response, error_1, exception, exception;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                _a.trys.push([0, 2, 3, 4]);
                                                return [4 /*yield*/, this.getAdapter().call(requestObject, options)];
                                            case 1:
                                                response = _a.sent();
                                                return [3 /*break*/, 4];
                                            case 2:
                                                error_1 = _a.sent();
                                                if (this.isLocationChanged) {
                                                    exception = new BrowserAbortError_1.default('Location has been changed with inflight request');
                                                    span.recordException(exception);
                                                    throw exception;
                                                }
                                                if (error_1 instanceof TypeError && error_1.message === 'Failed to fetch') {
                                                    exception = new BrowserAbortError_1.default('Request is failed to fetch');
                                                    span.recordException(exception);
                                                    throw exception;
                                                }
                                                if (Dispatcher.isAbortError(error_1)) {
                                                    span.recordException(error_1);
                                                    throw error_1;
                                                }
                                                response = error_1;
                                                return [3 /*break*/, 4];
                                            case 3:
                                                span.end();
                                                return [7 /*endfinally*/];
                                            case 4: return [2 /*return*/, response];
                                        }
                                    });
                                }); })];
                        case 2:
                            response = _a.sent();
                            if (requestObject instanceof RpcNotification_1.default) {
                                return [2 /*return*/, true];
                            }
                            return [4 /*yield*/, this.execResponseInterceptors((0, parse_1.default)(response), requestObject)];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            }); }, payload, options);
        };
        this.adapter = adapter;
        this.callManager = new CallManager_1.default();
        this.requestInterceptors = new Set();
        this.responseInterceptors = new Set();
        isBrowser && window.addEventListener('beforeunload', function () {
            _this.isLocationChanged = true;
        });
    }
    /**
     * Request
     * @deprecated Use .call method instead
     */
    Dispatcher.prototype.request = function (payload, options) {
        if (options === void 0) { options = {}; }
        return this.call(payload, options);
    };
    Dispatcher.prototype.abort = function (tags) {
        this.callManager.abort(tags);
    };
    /**
     * Notification
     *
     * @deprecated Use .call method instead
     */
    Dispatcher.prototype.notify = function (payload) {
        return this.call(payload);
    };
    /**
     * Add interceptor(s) before request
     */
    Dispatcher.prototype.interceptRequest = function (callbacks) {
        var _this = this;
        if (Array.isArray(callbacks)) {
            callbacks.forEach(function (callback) { return _this.requestInterceptors.add(callback); });
        }
        else {
            this.requestInterceptors.add(callbacks);
        }
        return this;
    };
    /**
     * Add interceptor(s) before response
     */
    Dispatcher.prototype.interceptResponse = function (callbacks) {
        var _this = this;
        if (Array.isArray(callbacks)) {
            callbacks.forEach(function (callback) { return _this.responseInterceptors.add(callback); });
        }
        else {
            this.responseInterceptors.add(callbacks);
        }
        return this;
    };
    /**
     * Delete interceptor(s) before response
     */
    Dispatcher.prototype.deleteRequestInterceptor = function (callbacks) {
        var _this = this;
        if (Array.isArray(callbacks)) {
            callbacks.forEach(function (callback) { return _this.requestInterceptors.delete(callback); });
        }
        else {
            this.requestInterceptors.delete(callbacks);
        }
        return this;
    };
    /**
     * Delete interceptor(s) before response
     */
    Dispatcher.prototype.deleteResponseInterceptor = function (callbacks) {
        var _this = this;
        if (Array.isArray(callbacks)) {
            callbacks.forEach(function (callback) { return _this.responseInterceptors.delete(callback); });
        }
        else {
            this.responseInterceptors.delete(callbacks);
        }
        return this;
    };
    /**
     * Exec request interceptors
     */
    Dispatcher.prototype.execRequestInterceptors = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.requestInterceptors.size) {
                            return [2 /*return*/, Promise.resolve(request)];
                        }
                        return [4 /*yield*/, __spreadArray([], __read(this.requestInterceptors), false).reduce(function (acc, callback) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = callback;
                                        return [4 /*yield*/, acc];
                                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                                }
                            }); }); }, Promise.resolve(request))];
                    case 1:
                        request = _a.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    /**
     * Exec response interceptors
     */
    Dispatcher.prototype.execResponseInterceptors = function (response, request) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.responseInterceptors.size) {
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        return [4 /*yield*/, __spreadArray([], __read(this.responseInterceptors), false).reduce(function (acc, callback) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = callback;
                                        return [4 /*yield*/, acc];
                                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), request])];
                                }
                            }); }); }, Promise.resolve(response))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Get adapter
     */
    Dispatcher.prototype.getAdapter = function () {
        return this.adapter;
    };
    /**
     * Set adapter
     *
     * @param {object} adapter
     * @return {Dispatcher}
     */
    Dispatcher.prototype.setAdapter = function (adapter) {
        this.adapter = adapter;
        return this;
    };
    Dispatcher.isAbortError = function (error) {
        return CallManager_1.default.isAbortError(error);
    };
    Dispatcher.isBrowserAbortError = function (error) {
        return CallManager_1.default.isBrowserAbortError(error);
    };
    return Dispatcher;
}());
exports.default = Dispatcher;
//# sourceMappingURL=Dispatcher.js.map